import React, { useEffect, useState, useRef } from "react";
import { Badge, Box, Grid, Stack, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { SIGNIN_ROUTE } from "../../constants/RoutePath";
import {
  authHeader,
  getLogUserId,
  getLogUserName,
  getLogUserRole,
} from "./MainFunction";
import {
  getAllNotificationDetails,
  getLoggedUserDetails,
} from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { deCryptFun, enCryptFun } from "./CustomFunction";
import { useToast } from "./CustomMessages";
import BillingInfoModel from "../model/BillingInfoModel";
import InvoiceHelpInfoModel from "../model/InvoiceHelpInfoModel";
import Notification from "../../images/notification.svg";
import NotificationActive from "../../images/notification-active.svg";
import NotificationModel from "../comman/NotificationModel";
import { GET_USER_NTE_NOTIFICATIONS } from "../../constants/ApiRoute";
import API from "./API";

export default function Navbar(props) {
  const { title, backFlag, backRoute } = props;
  const roles = getLogUserRole();
  let tyrole = [];
  //console.log("roles", roles);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationModel1, setNotificationModel1] = useState(false);
  // const [notificationDetails, setNotificationDetails] = useState([]);
  const notificationDetails = useSelector(
    (item) => item?.AllNotificationDetailsReducer
  );

  console.log(notificationDetails, "notificationModel1notificationModel1");
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = window.location.href;
  const urlSegments = url.split("/");
  const UrlValue = urlSegments[urlSegments.length - 1];
  const UrlValueDetailPage = urlSegments[urlSegments.length - 2];

  useEffect(() => {
    dispatch(getLoggedUserDetails());
    dispatch(getAllNotificationDetails());
  }, [notificationModel1, ]);
  const showToast = useToast();
  const backFun = () => {
    if (UrlValue == "add-project" || UrlValueDetailPage == "project-details") {
      localStorage.setItem("PROJECT_PAGE_BACKBUTTON_CLICK", true);
    }

    if (UrlValueDetailPage == "user-details" || UrlValue == "userlog") {
      localStorage.setItem("USER_PAGE_BACKBUTTON_CLICK", true);
    }

    if (typeof backRoute === "function") {
      backRoute(); // Call the function
    } else {
      navigate(`${backRoute}`);
      // navigate(`${backRoute}`, { state: { type: "backbutton" } });
    }

    //navigate(`${backRoute}`);
    // navigate(`${backRoute}`, { state: { type: "backbutton" } });
    //console.log(backRoute);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    const onStorageChange = (event) => {
      if (event.key === "logoutEvent") {
        localStorage.clear();

        navigate(SIGNIN_ROUTE);
      }
    };

    window.addEventListener("storage", onStorageChange);

    return () => {
      window.removeEventListener("storage", onStorageChange);
    };
  }, [navigate]);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    localStorage.clear();
    localStorage.setItem("logoutEvent", Date.now());
    navigate(SIGNIN_ROUTE);
  };
  if (typeof roles === "string") {
    // Convert to an array if it’s a string
    tyrole = roles.split(",");
    //  tyrole = [roles];
    //console.log("Converted roles:", roles);
    //console.log("Array.isArray(roles):", Array.isArray(roles)); // Should now be true
    //console.log("roles.length:", roles.length); // Should now be 1
  }

  const handleNotificationModel = () => {
    // dispatch(getAllNotificationDetails())
    setNotificationModel1(!notificationModel1);
    // setValue({ userId: getUserId(), count: 10, offset: 0 });
  };

  const getprojectDetails = async () => {
    let data = {
      userId: getLogUserId(),
    };

    console.log(data, "dataaaaaaaaaaa");
    const config = {
      method: "GET",
      url: GET_USER_NTE_NOTIFICATIONS,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      console.log(response, "responseeeeeeeeeee");
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        // setNotificationDetails(parsedResponse?.message)
        console.log(parsedResponse, "parsedResponseparsedResponse");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        // showToast(v.message, "error");
        console.log(v.message, "error");
      }
    }
  };

  // useEffect(()=>{
  //   getprojectDetails();
  //   console.log('CALLING_API')
  // },[])

  const filetredNotificationId = notificationDetails?.filter(
    (item) => !item?.IsRead
  );
  console.log(filetredNotificationId, "filetredNotificationId");
  return (
    <Box sx={{ ml: "-20px", mr: "-20px" }}>
      <Grid style={{ width: "100%" }} className="top-bar" container>
        <Grid sx={{ mt: "auto", mb: "auto" }} xs={5} md={8}>
          <Stack direction="row" spacing={1} alignItems="center">
            {backFlag == true && (
              <span
                style={{ cursor: "pointer" }}
                class="material-symbols-outlined back-arrow"
                onClick={backFun}
              >
                arrow_back
              </span>
            )}
            <Typography className="topbar-title">{title}</Typography>
          </Stack>
        </Grid>
        <Grid
          xs={7}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "end",
            gap: "1rem",
            padding: {
              xs: "3px 0px",
              sm: "6px 8px",
              md: "10px",
            },
          }}
        >
          {roles.includes("Admin") && (
            <Badge
              sx={{ my: "auto", mr: 1, cursor: "pointer", zIndex: "0" }}
              badgeContent={filetredNotificationId?.length}
              color="success"
              onClick={handleNotificationModel}
            >
              <Tooltip
                placement="top"
                arrow
                title="Notifications"
                componentsProps={{
                  tooltip: {
                    className: "tooltip",
                    sx: {
                      "& .MuiTooltip-arrow": {
                        color: "#202020",
                      },
                    },
                  },
                }}
              >
                <img
                  style={{ height: "fit-content" }}
                  src={notificationModel1 ? NotificationActive : Notification}
                  onClick={handleNotificationModel}
                  alt="Notification Icon"
                />
              </Tooltip>
            </Badge>
          )}
          <Box
            sx={{ textAlign: "right" }}
            // sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
          >
            {/* <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2, padding: "0", marginLeft: "0" }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          > */}
            {/* <Avatar sx={{ width: 32, height: 32 }}>M</Avatar> */}
            <Typography className="profile-name">{getLogUserName()}</Typography>
            {/* </IconButton> */}
            <Stack
              justifyContent="flex-end"
              direction="row"
              spacing={0.5}
              alignItems="center"
            >
              {/* { UrlValue == "billingstatement" || UrlValue == 'invoices' ?
            
            <span
            onClick={()=> {UrlValue == "billingstatement" ? setBillingHelpButton(true) : setInvoiceHelp(true) }}
            style={{
            fontSize: "24px",
            cursor: "pointer",
            }}
            class="material-symbols-outlined"
            >
            help
            </span>

            : ""} */}

              {roles.includes("Admin") && (
                <Typography className="role-name">Admin</Typography>
              )}
              {/* {console.log(typeof roles)}
            {console.log(Array.isArray(roles))} */}

              {tyrole && tyrole.length > 1 && (
                <Typography className="role-name"> | </Typography>
              )}
              {roles.includes("Broker") && (
                <Typography className="role-name">Broker</Typography>
              )}
            </Stack>
          </Box>
        </Grid>
        {notificationModel1 && (
          <NotificationModel
            notificationModel1={notificationModel1}
            setNotificationModel1={setNotificationModel1}
            notificationDetails={notificationDetails}
            filetredNotificationId={filetredNotificationId}
            getprojectDetails={getprojectDetails}
          />
        )}
      </Grid>
    </Box>
  );
}
